import classNames from 'classnames';
import { SelectHTMLAttributes, forwardRef, useState } from 'react';
import styles from './styles.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';

export type Option = {
  label: string;
  value: string;
};

type Variant = 'fit' | 'error' | 'mini' | 'isAbbreviation';
type Props = {
  options: Option[];
  variants?: Variant[];
} & Omit<SelectHTMLAttributes<HTMLSelectElement>, 'className' | 'style'>;

const Select = forwardRef<HTMLSelectElement, Props>(
  ({ options, variants = [], placeholder, onChange, ...props }, ref) => {
    const variantsClassName = variants.map((v) => styles[v]);
    const [dirty, setDirty] = useState(false);
    const selectClassNames = classNames(styles.input, ...variantsClassName);
    const containerClassNames = classNames(
      styles.container,
      ...variantsClassName.filter((c) => c !== styles.error)
    );
    return (
      <div className={containerClassNames}>
        <FontAwesomeIcon icon={faAngleDown} className={styles.icon} />
        <select
          {...props}
          ref={ref}
          className={selectClassNames}
          onChange={(...args) => {
            onChange?.(...args);
            setDirty(true);
          }}
        >
          {placeholder !== undefined && <option style={{ display: 'none' }} />}
          {options.map(({ label, value }) => (
            <option key={value} value={value}>
              {label}
            </option>
          ))}
        </select>
        {placeholder !== undefined &&
          (props.value === undefined ? !dirty : !props.value) && (
            <div className={styles.placeholder}>{placeholder}</div>
          )}
      </div>
    );
  }
);
Select.displayName = 'Select';

export default Select;
